export enum MomentKey {
  YEARS = "years",
  MONTHS = "months",
  WEEKS = "weeks",
  DAYS = "days",
  HOURS = "hours",
  MINUTES = "minutes",
  SECONDS = "seconds",
  MILLISECONDS = "milliseconds"
}

export enum MomentShortHand {
  YEARS = "y",
  MONTHS = "M",
  WEEKS = "w",
  DAYS = "d",
  HOURS = "h",
  MINUTES = "m",
  SECONDS = "s",
  MILLISECONDS = "ms"
}
